import { useEffect, useState } from "react";
import { Col, Row, Card, Button, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MarketerPurchasemodal from "../../../components/Marketer_Purchasemodal/index";
import { useNavigate } from "react-router-dom";
import {
  useGetSubscriptionMarketingQuery,
  useCheckMarketerSubscriptionStatusQuery,
} from "../../../features/marketing/marketingApiSlice";

const Marscriptionmdl = ({ lgShow, setLgShow, marketerId }) => {
  const navigate = useNavigate();
  const [paymentplan, setPaymentplan] = useState([]);
  const [planselected, setPlanselected] = useState("");
  const [showthePackages, setShowthePackages] = useState(true);
  const [purchase, setPurchase] = useState(false);
  const [statusChecked, setStatusChecked] = useState(false);
  const [hasPaidPlan, setHasPaidPlan] = useState(false);

  const shopid =
    localStorage.getItem("shopid") ||
    localStorage.getItem("OpenShopIdForMarketingByMarketer");
  const getbusinesstype = localStorage.getItem("BTtogetMarketer");

  // Debug modal visibility
  useEffect(() => {}, [lgShow, setLgShow, marketerId]);

  // RTK Query hooks
  const { data: subscriptionResponse } = useGetSubscriptionMarketingQuery();
  const { data: statusResponse } = useCheckMarketerSubscriptionStatusQuery(
    shopid,
    { skip: !lgShow || !shopid },
  );

  useEffect(() => {
    if (!lgShow) return;

    // Reset status state whenever modal opens
    setStatusChecked(false);
    setHasPaidPlan(false);
    setShowthePackages(true);
  }, [lgShow]);

  useEffect(() => {
    if (!lgShow || !statusResponse) return;

    const statusData = statusResponse?.data || statusResponse;
    if (statusData?.planisNotFree === true) {
      setHasPaidPlan(true);
    } else {
      setHasPaidPlan(false);
    }
    // Always show available packages so the shop owner can select a plan and hire a marketer
    setShowthePackages(true);
    setStatusChecked(true);
  }, [lgShow, statusResponse]);

  useEffect(() => {
    // Process subscription plans
    if (subscriptionResponse) {
      // Handle nested response structure
      const plansData =
        subscriptionResponse?.data?.data ||
        subscriptionResponse?.data ||
        subscriptionResponse;
      const plans = Array.isArray(plansData) ? plansData : [];

      const order = ["Basic", "Standard", "Premium"];

      const filteredPlans = plans
        .filter((plan) => plan && plan.planName && plan.planName !== "Free")
        .sort(
          (a, b) => order.indexOf(a?.planName) - order.indexOf(b?.planName),
        );
      setPaymentplan(filteredPlans);
    }
  }, [subscriptionResponse]);

  return (
    <>
      <MarketerPurchasemodal
        purchase={purchase}
        setPurchase={setPurchase}
        planselected={planselected}
        shopid={shopid}
        getbusinesstype={getbusinesstype}
        marketerId={marketerId}
      />

      <Modal
        size="xl"
        show={lgShow}
        onHide={() => setLgShow(false)}
        backdrop="static"
        keyboard={false}
        centered
        aria-labelledby="subscription-modal-title"
      >
        <Modal.Header
          style={{ backgroundColor: "#0353A4" }}
          closeButton
        ></Modal.Header>

        <Modal.Body className="p-5 pb-2">
          <Row className="justify-content-center align-items-stretch">
            {showthePackages && paymentplan?.length > 0 ? (
              paymentplan.map((plan) => (
                <Col lg={6} xl={6} className="p-4" key={plan._id}>
                  <Card
                    className="cardsettingss"
                    style={{ borderRadius: "20px" }}
                  >
                    <Card.Body>
                      {/* ✅ PLAN NAME LEFT SIDE */}
                      <div className="mb-2">
                        <h5
                          style={{
                            color: "#003559",
                            fontWeight: "bold",
                            letterSpacing: "1px",
                          }}
                        >
                          {plan?.planName?.toUpperCase()}
                        </h5>
                      </div>

                      <div className="ps-3 pe-3">
                        {/* PRICE */}
                        <div className="mt-2">
                          <h3
                            style={{
                              color: "#0353A4",
                              fontFamily: "monospace",
                            }}
                          >
                            {plan?.pricing?.monthly?.currency} :
                            {plan?.pricing?.monthly?.amount}
                          </h3>
                        </div>

                        {/* ✅ LIMITS FIRST WITH BULLETS */}
                        <div className="mt-3">
                          <h6 style={{ color: "#003559", fontWeight: "bold" }}>
                            Limits
                          </h6>

                          <ul
                            style={{
                              color: "#0353A4",
                              fontSize: "small",
                              paddingLeft: "18px",
                            }}
                          >
                            <li>
                              Public Connections:{" "}
                              {plan?.limits?.publicConnections}
                            </li>
                            <li>
                              B2B Connections: {plan?.limits?.b2bConnections}
                            </li>
                            <li>
                              Post Ads Limit: {plan?.limits?.postAdsLimit}
                            </li>
                            <li>Items Limit: {plan?.limits?.itemsLimit}</li>
                            <li>
                              Promote Shop Limit:{" "}
                              {plan?.limits?.promoteShopLimit}
                            </li>
                          </ul>
                        </div>

                        {/* ✅ FEATURES HEADING */}
                        <div className="mt-3">
                          <h6 style={{ color: "#003559", fontWeight: "bold" }}>
                            Features
                          </h6>

                          {plan?.features?.map((f) => (
                            <div
                              key={f._id}
                              className="d-flex align-items-start"
                            >
                              <CheckCircleIcon
                                style={{
                                  color: "rgb(0, 53, 89)",
                                  width: "10%",
                                }}
                              />
                              <span
                                className="ms-2"
                                style={{
                                  color: "#0353A4",
                                  fontSize: "small",
                                }}
                              >
                                {f?.title}
                              </span>
                            </div>
                          ))}
                        </div>

                        {/* SUBSCRIBE BUTTON */}
                        <div className="mt-5 mb-3">
                          <button
                            className="w-100 py-2 cursor_P"
                            style={{
                              backgroundColor: "#267DCF",
                              borderRadius: "30px",
                              color: "#FFFFFF",
                              border: "none",
                              fontSize: "small",
                            }}
                            onClick={() => {
                              setPlanselected(plan?._id);
                              setPurchase(true);
                              setLgShow(false);
                            }}
                          >
                            Subscribe
                          </button>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : !statusChecked ? (
              <Col xs={12} className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <div className="mt-3" style={{ color: "#0353A4" }}>
                  Checking subscription status...
                </div>
              </Col>
            ) : hasPaidPlan ? (
              <Col xs={12} className="text-center py-5">
                <div style={{ color: "#0353A4" }}>
                  You already have a paid marketing subscription.
                </div>
                <Button
                  variant="primary"
                  className="mt-3"
                  onClick={() => navigate("/marketer-invoice")}
                >
                  View Invoice
                </Button>
              </Col>
            ) : paymentplan?.length > 0 ? (
              paymentplan.map((plan) => (
                <Col lg={6} xl={6} className="p-4" key={plan._id}>
                  <Card
                    className="cardsettingss"
                    style={{ borderRadius: "20px" }}
                  >
                    <Card.Body>
                      {/* ✅ PLAN NAME LEFT SIDE */}
                      <div className="mb-2">
                        <h5
                          style={{
                            color: "#003559",
                            fontWeight: "bold",
                            letterSpacing: "1px",
                          }}
                        >
                          {plan?.planName?.toUpperCase()}
                        </h5>
                      </div>

                      <div className="ps-3 pe-3">
                        {/* PRICE */}
                        <div className="mt-2">
                          <h3
                            style={{
                              color: "#0353A4",
                              fontFamily: "monospace",
                            }}
                          >
                            {plan?.pricing?.monthly?.currency} :
                            {plan?.pricing?.monthly?.amount}
                          </h3>
                        </div>

                        {/* ✅ LIMITS FIRST WITH BULLETS */}
                        <div className="mt-3">
                          <h6 style={{ color: "#003559", fontWeight: "bold" }}>
                            Limits
                          </h6>

                          <ul
                            style={{
                              color: "#0353A4",
                              fontSize: "small",
                              paddingLeft: "18px",
                            }}
                          >
                            <li>
                              Public Connections:{" "}
                              {plan?.limits?.publicConnections}
                            </li>
                            <li>
                              B2B Connections: {plan?.limits?.b2bConnections}
                            </li>
                            <li>
                              Post Ads Limit: {plan?.limits?.postAdsLimit}
                            </li>
                            <li>Items Limit: {plan?.limits?.itemsLimit}</li>
                            <li>
                              Promote Shop Limit:{" "}
                              {plan?.limits?.promoteShopLimit}
                            </li>
                          </ul>
                        </div>

                        {/* ✅ FEATURES HEADING */}
                        <div className="mt-3">
                          <h6 style={{ color: "#003559", fontWeight: "bold" }}>
                            Features
                          </h6>

                          {plan?.features?.map((f) => (
                            <div
                              key={f._id}
                              className="d-flex align-items-start"
                            >
                              <CheckCircleIcon
                                style={{
                                  color: "rgb(0, 53, 89)",
                                  width: "10%",
                                }}
                              />
                              <span
                                className="ms-2"
                                style={{
                                  color: "#0353A4",
                                  fontSize: "small",
                                }}
                              >
                                {f?.title}
                              </span>
                            </div>
                          ))}
                        </div>

                        {/* SUBSCRIBE BUTTON */}
                        <div className="mt-5 mb-3">
                          <button
                            className="w-100 py-2 cursor_P"
                            style={{
                              backgroundColor: "#267DCF",
                              borderRadius: "30px",
                              color: "#FFFFFF",
                              border: "none",
                              fontSize: "small",
                            }}
                            onClick={() => {
                              setPlanselected(plan?._id);
                              setPurchase(true);
                              setLgShow(false);
                            }}
                          >
                            Subscribe
                          </button>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <Col xs={12} className="text-center py-5">
                <div style={{ color: "#0353A4" }}>
                  No subscription plans available at the moment.
                </div>
              </Col>
            )}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Marscriptionmdl;
